import { Close, ContentCopy } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import { EmailField, useNotify, useRecordContext } from "react-admin";

const EmailWithCopy = ({ source = "email" }: any) => {
  const record = useRecordContext();
  const notify = useNotify();

  if (!record[source]) return <Close fontSize="inherit" />;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(record[source]);
      notify("Email copied to clipboard", { type: "info" });
    } catch (err) {
      notify("Failed to copy email", { type: "warning" });
    }
  };

  return (
    <span style={{ display: "inline-flex", alignItems: "center" }}>
      <EmailField source={source} />
      <Tooltip title="Copy to clipboard">
        <IconButton
          size="small"
          onClick={handleCopy}
          sx={{ ml: 0.5 }} // small left margin for spacing
        >
          <ContentCopy fontSize="inherit" />
        </IconButton>
      </Tooltip>
    </span>
  );
};

export default EmailWithCopy;
